<template>
	<div :id="baseId" class="product-highlights-panel d-flex flex-column">
		<div class="product-highlights-panel-carousel d-flex flex-column">
			<div class = 'slide_header'>
				<h1> Find the Perfect Plan for You </h1>
				<h2> Maximize your potential, minimize the cost - everything you need to grow your business, your way. </h2>
			</div>
			<div class="type">
				<h2 @click="togglePlan('monthly')" :class="{ active: planType === 'monthly' }"> Monthly </h2>
				<div class="toggle"></div>
				<h2 @click="togglePlan('annual')" :class="{ active: planType === 'annual' }"> Annual <span>(Save 20%)</span> </h2>
			</div>
			<div class='cards'>
				<div class = 'card'>
					<img class = 'plan' src = '@/assets/images/home/v8/stan-creator.svg' alt = 'Feature Emoji'>
					<div class="price">
						<h1>{{ formattedPrice(planType, 29, 25) }}<span>/mo</span></h1>
						<h2> or <b>~${{ formattedDailyPrice(planType, 29, 25) }}</b>/day </h2>
					</div>
					<div class = 'features'>
						<div class = 'col'>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-phone.png' alt = 'Feature Emoji'>
								</div>
								<h3> Mobile Optimized <br> "Link-in-Bio" Store </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-calendar.png' alt = 'Feature Emoji'>
								</div>
								<h3> Coaching Calls </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-course.png' alt = 'Feature Emoji'>
								</div>
								<h3> Course Builder </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-chart.png' alt = 'Feature Emoji'>
								</div>
								<h3> Audience Analytics </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-plane.png' alt = 'Feature Emoji'>
								</div>
								<h3> Instagram AutoDMs </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-community.png' alt = 'Feature Emoji'>
								</div>
								<h3> Community </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-webinar.png' alt = 'Feature Emoji'>
								</div>
								<h3> Webinars </h3>
							</div>
						</div>
						<div class = 'col'>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-product.png' alt = 'Feature Emoji'>
								</div>
								<h3> Digital Products </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-link.png' alt = 'Feature Emoji'>
								</div>
								<h3> Links / URLs </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-hand.png' alt = 'Feature Emoji'>
								</div>
								<h3> 1-Tap Checkout </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-magnet.png' alt = 'Feature Emoji'>
								</div>
								<h3> Lead Magnets & Email Lists </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-app.png' alt = 'Feature Emoji'>
								</div>
								<h3> Custom Mobile App </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-call.png' alt = 'Feature Emoji'>
								</div>
								<h3> 24/7 Creator Support </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-cycle.png' alt = 'Feature Emoji'>
								</div>
								<h3> Subscriptions & <br>Memberships </h3>
							</div>
						</div>
					</div>

					<button class='button'  @click="$emitter.emit('register', 'pricing-creator')">
						<h2> Start Free Trial </h2>
						<img src="@/assets/images/home/v6/arrow.svg" />
					</button>


				</div>
				<div class = 'card'>
					<img class = 'plan' src = '@/assets/images/home/v8/stan-creator-pro.svg' alt = 'Feature Emoji'>
					<div class="price">
						<h1>{{ formattedPrice(planType, 99, 79) }}<span>/mo</span></h1>
						<h2> or <b>~${{ formattedDailyPrice(planType, 99, 79) }}</b>/day </h2>
					</div>
					<h2 class = 'text'> Everything in the Stan Creator Plan, plus: </h2>
					<div class = 'features'>
						<div class = 'col'>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-mail.png' alt = 'Feature Emoji'>
								</div>
								<h3> Email Marketing Flows </h3>
							</div>
							<!-- <div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-infinity.png' alt = 'Feature Emoji'>
								</div>
								<h3> Unlimited Funnels </h3>
							</div> -->
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-money.png' alt = 'Feature Emoji'>
								</div>
								<h3> Discount Codes & Upsell Offers </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-affiliate.png' alt = 'Feature Emoji'>
								</div>
								<h3> Affiliate Links </h3>
							</div>
							<div class = 'feature'>
								<div class = 'emoji'>
									<img src = '@/assets/images/home/v8/emoji-chart.png' alt = 'Feature Emoji'>
								</div>
								<h3> Pixel Tracking </h3>
							</div>
						</div>
					</div>
					<button class='button'  @click="$emitter.emit('register', 'pricing-creator-pro')">
						<h2> Start Free Trial </h2>
						<img src="@/assets/images/home/v6/arrow.svg" />
					</button>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { computed, defineComponent, getCurrentInstance, ref, inject } from 'vue'
	import { Swiper, SwiperSlide } from 'swiper/vue'
	import { Zoom, Navigation } from 'swiper'
	import { client } from '@/plugins/platform'
	import TrialButton from '@/components/shared/TrialButton.vue'

	const $emitter = inject('$emitter')

	export default defineComponent({
		name: 'Landingv8ProductHighlights',
		setup() {
			const planType = ref('monthly')
			const togglePlan = (type) => {
				planType.value = type
			}
			const formattedPrice = (planType, monthlyPrice, annualPrice) => {
				return planType === 'annual' ? `$${annualPrice}` : `$${monthlyPrice}`
			}
			const formattedDailyPrice = (planType, monthlyPrice, annualPrice) => {
				const price = planType === 'annual' ? annualPrice : monthlyPrice
				return (price / 30).toFixed(2)
			}
			return {
				planType,
				togglePlan,
				formattedPrice,
				formattedDailyPrice,
			}
		},
	})
</script>
<style lang="scss" scoped>

	@import '@/assets/styles/helpers-v6.scss';

	::-webkit-scrollbar{
		height: 0;
	}

	:deep(#cta){
		background: #6355FF;
		color: white;
		padding: 16px 20px;
		border-radius: 12px;
		img{
			filter: invert(100%);
		}
	}


	.product-highlights-panel{
		background: #F0F3FA;
	}

	.product-highlights-panel {
		font-family: Plus Jakarta Sans, sans-serif;
		min-height: 100vh;
		padding-top: 40px;
		padding-bottom: 80px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.type{
		background: rgba(white, 0.75);
		display: flex;
		border-radius: 16px;
		width: fit-content;
		margin: auto;
		margin-bottom: 24px;
		h2{
			font-size: 14px;
			padding: 8px 12px;
			font-weight: 700;
			opacity: 0.4;
			border-radius: 16px;
			cursor: pointer;
			margin: 0;
			box-shadow: 0 8px 16px rgba(#00106D, 0.05);
			span{
				font-size: 12px;
				font-weight: 500;
				margin: 0;
			}
			&.active{
				opacity: 1;
				background: white;
				box-shadow: 0 6px 16px rgba(#00106D, 0.12);
			}
		}
	}


	.button{
		background: #6355ff;
		color: white;
		border: none;
		display: flex;
		align-items: center;
		padding: 14px 20px 16px 20px;
		border-radius: 12px;
		gap: 12px;
		transition: 0.2s ease;

		h2{
			font-size: 18px;
			font-weight: 600;
			margin: 0;
		}

		img{
			height: 18px;
			width: 18px !important;
			filter: invert(100%) brightness(1000%);
		}

		&:hover{
			background: #5200ff;
			gap: 16px;
		}
	}

	#bar{
		background: #dde3f5;
		width: 700px;
		height: 5px;
		border-radius: 50px;
		margin: auto;
		position: relative;
		#progress{
			height: 5px;
			width: 10px;
			background: #00106D;
			position: absolute;
			top: 0;
			left: 0;
			border-radius: 50px;
		}
		#bars{
			width: 700px;
			height: 5px;
			top: 0;
			left: 0;
			position: absolute;
			display: flex;
			justify-content: space-between;
			.bar{
				width: 15px;
				height: 5px;
				background: white;
			}
		}
	}

	#gap{
			width: 100px;
			height: 40px;
			color: white;
		}

	.cards{
		display: flex;
		gap: 24px;
		max-width: 100vw;
		overflow-y: visible;
		overflow-x: scroll;
		padding: 30px;
	}

	.card{
		background: white;
		border: none;
		box-shadow: 0 15px 25px rgba(#00106D, 0.1);
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		width: fit-content;
		gap: 32px;
		padding: 32px;
		border-radius: 12px;

		.text{
			font-size: 14px;
			font-weight: 500;
			padding: 12px 16px;
			width: 100%;
			border-radius: 8px;
			margin-bottom: -16px;
			margin-top: -8px;
			background: #EBEBFF;
		}

		.plan{
			height: 28px;
			width: auto !important;
		}

		.price{
			h1{
				font-size: 40px;
				font-weight: 800;
				span{
					font-size: 20px;
					font-weight: 400;
				}
			}
			h2{
				font-size: 16px;
				color: #808eB2;
			}
		}

		.features{
			display: flex;
			gap: 16px;
			.col{
				display: flex;
				flex-direction: column;
				gap: 8px;
			}
		}

		.feature{
			display: flex;
			align-items: center;
			gap: 8px;
			.emoji{
				img{
					height: 32px;
					width: 32px !important;
				}
			}
			h3{
				font-size: 14px;
				letter-spacing: 0px;
				font-weight: 500;
				margin: 0;
			}
		}
	}

	@media screen and (max-width: 800px){
		.slide_header{
			padding: 0;
		}
		.type{
			margin-bottom: 18px;
			margin-top: 32px;
			h2{
				font-size: 18px;
				padding: 12px 16px;
			}
		}
		.cards{
			width: 100vw;
			overflow-x: scroll !important;

			.card{
				width: 75vw;
				flex-shrink: 0;
				height: fit-content;

				.features{
					flex-direction: column;
					gap: 8px;
				}
			}
		}
		.product-highlights-panel{
			padding-bottom: 30px;
		}
	}
</style>